export enum GenerationJobParsingMode {
  TABULAR = 'TABULAR',
  DEFAULT = 'DEFAULT',
}